import { useEffect, useMemo } from "react";
import { daysTextForm, declOfNum } from "/utils";
import { useDispatch, useSelector } from "react-redux";
import clsx from "clsx";
import { useRouter } from "next/router";
import Icon from "../../../common/icon";
import styles from "./index.module.scss";
// eslint-disable-next-line import/named
import { fetchDelivery } from "../../../../redux/action-creaters/product";

export default function Delivery({
  productId,
  isBaltex = false,
  isLanding = false,
}) {
  const { deliveryNew } = useSelector((state) => state.product);
  const { cityName } = useSelector((state) => state.location);
  const { contacts, shops: shopsList = [] } = useSelector(
    (state) => state.contacts,
  );
  const { edostMinDays } = useSelector((state) => state.location);

  const router = useRouter();
  const dispatch = useDispatch();
  useEffect(() => {
    if (shopsList?.length > 0) {
      dispatch(
        fetchDelivery(
          [productId],
          shopsList.map((shop) => shop.id),
          router.query.time,
          router.query.weekday,
        ),
      );
    }
  }, [shopsList]);

  const deliveryProductInfoNew = useMemo(() => {
    const text = [];
    if (contacts?.name === "Центральный" && edostMinDays?.days > 0) {
      text.push(`Доставка в г. ${cityName} транспортными компаниями`);
      text.push(`от ${declOfNum(edostMinDays.days, ["дня", "дней", "дней"])}`);
    } else if (deliveryNew?.length > 0) {
      const nowShops = deliveryNew.filter(
        (shop) => shop.availabilityType === "now",
      );
      const relocationShops = deliveryNew.filter(
        (shop) => shop.availabilityType === "relocation",
      );
      let relocationMinDays = null;
      if (relocationShops.length > 0) {
        relocationShops.forEach((shop) => {
          if (!relocationMinDays || shop.days < relocationMinDays) {
            relocationMinDays = shop.days;
          }
        });
      }

      if (nowShops.length > 0) {
        text.push("Есть в наличии на самовывоз из");
        text.push(
          declOfNum(nowShops.length, ["магазина", "магазинов", "магазинов"]),
        );
        text.push(daysTextForm(nowShops[0].days));
        if (relocationShops.length > 0) {
          text.push("и под заказ в");
          text.push(
            declOfNum(relocationShops.length, [
              "магазина",
              "магазинов",
              "магазинов",
            ]),
          );
          text.push(daysTextForm(relocationMinDays));
        }
      } else if (relocationShops.length > 0) {
        text.push("Под заказ из");
        text.push(
          declOfNum(relocationShops.length, [
            "магазина",
            "магазинов",
            "магазинов",
          ]),
        );
        text.push(daysTextForm(relocationMinDays));
      }
    }
    return text.join(" ");
  }, [deliveryNew, productId]);

  return (
    <div
      className={clsx(
        isBaltex && styles.DeliveryBaltex,
        styles.Delivery,
        isLanding && styles.DeliveryLanding,
      )}
    >
      <div>Доставка</div>
      <div>{deliveryProductInfoNew}</div>
      {!isBaltex && (
        <div
          className={styles.Link}
          onClick={() => {
            const section = document.getElementById("delivery");
            section.click();
            section.scrollIntoView({ behavior: "smooth", block: "start" });
          }}
        >
          Рассчитать стоимость
          {!isLanding && <Icon id="calc" width={18} height={18} />}
        </div>
      )}
    </div>
  );
}
